import * as React from "react";
import capitalize from "lodash/capitalize";
import * as colors from "../settings/colors";
import { Table, TableRow, TableCell } from "./Table";
import joinPath from "../utils/join-path";
import Link from "./Link";

const columnSizing = "1fr 1fr";

const roleOrder = ["admin", "manager", "draftsman", "franchisee"];

const UsersList = ({ users, match, ...otherProps }) => {
  const sortedUsers = users.slice().sort((a, b) => {
    const indexA = roleOrder.indexOf(a.role);
    const indexB = roleOrder.indexOf(b.role);

    if (indexA === indexB) {
      if (!a.name) return 1;
      if (!b.name) return -1;

      const nameA = (a.name || "").toUpperCase();
      const nameB = (b.name || "").toUpperCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    }

    return indexA - indexB;
  });

  const renderUser = user => {
    const userLink = joinPath(match.url, `/${user.id}`);
    const deactivatedColor = user.deactivated && colors.TEXT_TERTIARY;

    return (
      <TableRow
        key={`user-${user.id}`}
        columns={columnSizing}
        style={{
          backgroundColor: user.deactivated ? colors.DIVIDER : "transparent"
        }}
      >
        <TableCell>
          <span>
            {user.name && (
              <span>
                <b>
                  <Link to={userLink} color={deactivatedColor}>
                    {user.name}
                  </Link>
                </b>
                <br />
              </span>
            )}
            <Link
              to={userLink}
              color={
                user.deactivated ? colors.TEXT_TERTIARY : colors.TEXT_SECONDARY
              }
            >
              {user.email}
            </Link>
          </span>
        </TableCell>
        <TableCell>{capitalize(user.role)}</TableCell>
      </TableRow>
    );
  };

  return (
    <Table noSideBorders {...otherProps}>
      <TableRow header columns={columnSizing}>
        <TableCell>Name &amp; Email</TableCell>
        <TableCell>Role</TableCell>
      </TableRow>
      {sortedUsers.map(renderUser)}
    </Table>
  );
};

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/UsersList.js